module.exports = __webpack_public_path__ + "static/img/can-lemon.cd05b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-lemon.png
// module id = 5in2
// module chunks = 0